import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'factura', namespaced: true })

export default mystore
